import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SnotifyService } from 'ng-alt-snotify';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(
    private snotifyService: SnotifyService,
    private translate: TranslateService,
  ) {}

  /**
   * alert success.
   * @param msg message shown in the body
   * @author Martin Batun Tec.
   */
  success(msg: string, opt: { [k: string]: any } = {}) {
    const isOptEmpty = Object.keys(opt).length === 0;
    if (isOptEmpty) {
      opt = { timeout: 3_000 };
    }

    return this.snotifyService.success(
      this.translate.instant(msg),
      this.translate.instant('alert:successTitle'),
      opt,
    );
  }

  public warning(msg: string, opt: { [k: string]: any } = {}) {
    const isOptEmpty = Object.keys(opt).length === 0;
    if (isOptEmpty) {
      opt = { timeout: 30_000 };
    }

    return this.snotifyService.warning(
      this.translate.instant(msg),
      this.translate.instant('alert:warningTitle'),
      opt,
    );
  }

  /**
   * alert error.
   * @param msg message shown in the body
   * @author Martin Batun Tec.
   */
  error(msg: string, opt: { [k: string]: any } = {}) {
    const isOptEmpty = Object.keys(opt).length === 0;
    if (isOptEmpty) {
      opt = { timeout: 45_000 };
    }

    return this.snotifyService.error(
      this.translate.instant(msg),
      this.translate.instant('alert:errorTitle'),
      opt,
    );
  }

  /**
   * alert remove.
   * @param msg message shown in the body
   * @author Martin Batun Tec.
   */
  remove(
    msg: string,
    title: string = 'alert:removeTitle',
    confirm: string = 'shared:yes',
    decline: string = 'shared:close',
  ): Promise<void> {
    return new Promise(async (resolve): Promise<void> => {
      this.snotifyService.confirm(
        this.translate.instant(msg),
        this.translate.instant(title),
        {
          buttons: [
            {
              text: this.translate.instant(confirm),
              action: (toast) => {
                this.snotifyService.remove(toast.id);
                resolve();
              },
            },
            {
              text: this.translate.instant(decline),
              action: (toast) => {
                this.snotifyService.remove(toast.id);
              },
            },
          ],
        },
      );
    });
  }
}
